/** Re-export for backward compatibility; implementation lives in schema/ */
export * from './schema/index';
